import { useContextualMenu } from '@databases/contextual-menu';
import usePanel from '@databases/panel/usePanel';
import usePanelState from '@databases/panel/usePanelState';
import { useKeyboardShortcut } from '@databases/react';
import { defaultStoreUtils } from '@databases/redux';
import { deselectAll, setSoftSelection } from '@databases/redux/cellSelections/actions';
import { removeTextSelection } from '@databases/utils/database/utils';
import { useViewUiState } from '@databases/views/useViewUiState';

import { CLOSE_SHORTCUT } from '../shortcuts';

const useCloseViewPanelKeyboardShortcut = () => {
  const { hidePanel } = usePanel();
  const { isPanelVisible } = usePanelState();
  const { setActivePanelSetting } = useViewUiState();
  const dispatch = defaultStoreUtils.useDispatch();
  const { closeMenu } = useContextualMenu();

  useKeyboardShortcut(
    CLOSE_SHORTCUT,
    () => {
      if (isPanelVisible()) {
        // when we remove the view settings panel from the panel stack (i.e. the
        // top/visible panel is the view settings panel), we want to clear its settings
        if (isPanelVisible('ViewSettingsPanel')) {
          setActivePanelSetting(null);
        }
        hidePanel();
        dispatch(setSoftSelection({ value: false }));
      } else {
        removeTextSelection();
        dispatch(deselectAll());
        closeMenu();
      }
    },
    false
  );
};

export default useCloseViewPanelKeyboardShortcut;
